const WarehouseSite = `
  id
  name
  description
	updatedAt
`;

export default WarehouseSite;
